// =============================================================================
//  Product-name normalization — MUST stay byte-for-byte identical to the
//  scraper's gateway/src/product-cache.ts implementation.
//
//  Both sides key the `products` table on `normalized_name`. If they diverge,
//  cache lookups will silently miss. Copy verbatim; never rewrite.
// =============================================================================

/**
 * Produces the canonical normalized_name used as the Supabase cache key.
 *
 * Algorithm (matches scraper exactly):
 *   1. Lowercase
 *   2. Replace non-alphanumeric Unicode chars with a single space
 *   3. Collapse runs of whitespace into one space
 *   4. Trim leading/trailing whitespace
 *
 * Examples:
 *   "Sony WH-1000XM5"           → "sony wh 1000xm5"
 *   "  Bose QuietComfort  Ultra " → "bose quietcomfort ultra"
 *   "Café du Monde"              → "café du monde"   (Unicode letters preserved)
 *   "DeLonghi La Specialista!"   → "delonghi la specialista"
 */
export function normalizeProductName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]+/gu, " ") // Unicode-aware: keep letters/digits
    .replace(/\s+/g, " ")
    .trim();
}
